import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/App.css";
import "./main/index.css";
import App from "./main/App";
import reportWebVitals from "./main/reportWebVitals";
import "./i18n/config"; // Import i18n config
import {ConfigProvider} from "antd";
import ptBR from "antd/locale/pt_BR";
import {UserbackProvider} from "@userback/react";
import {configProject} from "./config-project";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "./components/theme-provider-component/theme-provider-component";
import { AppErrorFallback } from "./main/error-fallback";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

Sentry.init({
  dsn: sentryDsn,
  // No DSN locally → keep Sentry inert instead of swallowing events silently.
  enabled: Boolean(sentryDsn),
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
  release: process.env.REACT_APP_RELEASE,
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: +(process.env.REACT_APP_SENTRY_TRACE || 0),
  // Never ship auth credentials to Sentry (Axios errors carry the request config).
  beforeSend(event) {
    const headers = event.request?.headers;
    if (headers) {
      delete headers["Authorization"];
      delete headers["authorization"];
      delete headers["x-access-token"];
    }
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={({ resetError }) => <AppErrorFallback onReset={resetError} />}>
    <UserbackProvider token={process.env.REACT_APP_USER_BACK} options={{ locale: 'pt' }}>
      <ConfigProvider
        locale={ptBR}
        theme={{
          token: {
            colorPrimary: configProject.colorPrimary,
            colorLink: configProject.colorLink,
          },
        }}
      >
        <ThemeProvider>
           <App/>
        </ThemeProvider>
      </ConfigProvider>
    </UserbackProvider>
  </Sentry.ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
